import { useContext, useEffect, useState } from "react";
import { FirebaseAuthContext } from "../../../commons/firebase/FirebaseAuthProvider";
import { firebaseService } from "../../../commons/firebase/Firebase";

// Hook for fetching the next unplayed scored scene in a course playlist

const useLoadNextScoredScene = (
    playlistId,
    courseId,
    scoredSceneId,
    isReplay
) => {
    const [scene, setScene] = useState([]);

    const [loadingScene, setLoadingScene] = useState(true);

    const { signedInUser } = useContext(FirebaseAuthContext);

    // Retrieving the courses and setting the list in the state variable
    const fetchNextScene = async () => {
        try {
            const idToken = await signedInUser.getIdToken();
            const dataFromServer = !isReplay
                ? await fetch(
                    "/reg-main/playlists/" +
                    playlistId +
                    "/" +
                    signedInUser.uid +
                    "/" +
                    courseId +
                    "/scoredScenes/next?idToken=" +
                    idToken
                )
                : await fetch(
                    "/reg-main/scoredScenes/" + scoredSceneId + "?idToken=" + idToken
                );
            /*
                  Only set the user list in case the REST response was successful.
                  Otherwise (e.g. 401 - Unauthorized), logout the Firebase user.  
                   */
            if (dataFromServer.status === 200) {
                const nextSceneJson = await dataFromServer.json();
                setScene(nextSceneJson);
                setLoadingScene(false);
            } else {
                // This will lead to a re-direct to the main login page
                await firebaseService.auth().signOut();
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchNextScene();
    }, []);

    return { scene, loadingScene };
};

export default useLoadNextScoredScene;
